<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="60%" persistent @input="closeModal">
      <v-card class="card">
        <v-card-title class="headline accent--text pb-4">
          {{ isEdit ? 'Редактировать' : 'Добавить' }}
        </v-card-title>
        <v-card-text outlined tile class="border-top">
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0 pt-6">
                <v-text-field
                  v-model="protocol.protocolNumber"
                  label="Номер протокола"
                  placeholder="Введите номер протокола"
                  outlined dense rounded
                  v-mask="'########'"
                  @input="$v.protocol.protocolNumber.$touch()"
                  @blur="$v.protocol.protocolNumber.$touch()"
                  :error-messages="errorMessages.protocolNumber"
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <UIDatePicker
                  label="Дата протокола"
                  v-model="protocol.protocolDate"
                  :error-messages="errorMessages.protocolDate"
                  @input="$v.protocol.protocolDate.$touch()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal"> {{ 'Отмена' }} </v-btn>
          <v-btn
            :loading="loading"
            :disabled="$v.$invalid"
            color="success"
            text
            @click="saveProtocol"
          >
            {{ isEdit ? 'Сохранить' : 'Создать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  required,
  maxLength
} from 'vuelidate/lib/validators'
import  {
  protocolApi,
  specialityApi
} from '@/api'
import { Protocol } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import UIDatePicker from '@/components/ui/UIDatePicker'
import {cloneDeep} from "lodash";

export default {

  components: {
    UIDatePicker,
  },

  props: {
    loading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  async created() {
    await this.getGroups()
  },

  data: () => ({
    protocol: new Protocol(),
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    speciality: [],
  }),

  validations() {
    return {
      protocol: {
        protocolDate: { required },
        protocolNumber: { required }
      }
    }
  },

  computed: {
    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.protocol.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.protocol[key])
      })

      return allErrors
    }
  },

  methods: {
    async getGroups() {
      this.speciality = await specialityApi.getCatalog()
    },

    saveProtocol() {
      this.$emit('saveProtocol', this.protocol.getForAPI())
    },

    resetModal() {
      this.$v.$reset()
      this.protocol = new Protocol()
    },

    closeModal() {
      this.protocol = new Protocol()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.protocol = val ? Protocol.buildFromAPI(val) : new Protocol()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}
</style>